import React from 'react';
import useLink from 'Hooks/useLink';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import PlannerInformation
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/PlannerInformationPicker/PlannerInformation/PlannerInformation';

const PlannerInformationContainer = ({ link, direction }) => {
  const [debouncedLink, setDebouncedLink] = React.useState(link);

  const {
    isInitializing,
    loading,
    loadingError,
    collection,
    refreshCollection,
  } = useLink(
    debouncedLink,
  );

  React.useEffect(() => {
    setDebouncedLink(link);
  }, [link?.url()]);

  return (
    <DataContainer
      component={PlannerInformation}
      loading={isInitializing || loading}
      loadingError={loadingError}
      componentProps={{
        collection,
        refreshCollection,
        direction,
      }}
    />
  );
};

PlannerInformationContainer.defaultProps = {
  direction: 'column',
};

PlannerInformationContainer.propTypes = {
  link: PropTypes.object.isRequired,
  direction: PropTypes.oneOf(['row, column']),
};

export default PlannerInformationContainer;
